"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _classnames = _interopRequireDefault(require("classnames"));

var _AutoHeightTextArea = _interopRequireDefault(require("../../../../AutoHeightTextArea"));

var _ShotImage = _interopRequireDefault(require("./ShotImage"));

var Shot = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Shot, _Component);

  function Shot(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Shot);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Shot).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateField", function (fieldName) {
      return function (_ref) {
        var value = _ref.target.value;
        var updateShot = _this.props.updateShot;

        if (fieldName === 'description') {
          return void updateShot((0, _defineProperty2.default)({}, fieldName, value));
        }

        _this.setState({
          script: value
        }, function () {
          _this.updateShot((0, _defineProperty2.default)({}, fieldName, value));
        });
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateAsset", function (assetId) {
      var updateShot = _this.props.updateShot;
      updateShot({
        assetId: assetId
      });
    });
    _this.state = {
      script: props.script || ''
    };
    _this.updateShot = (0, _lodash.default)(props.updateShot, 100);
    return _this;
  }

  (0, _createClass2.default)(Shot, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_ref2) {
      var script = _ref2.script;
      var props = this.props; // We manage both state + props for performance reasons. We use state for local updates then a
      // debounce to update the props. When the script is changed in the drawer we need to update
      // our cached version of this shot's script text. The if statement protects from infinite loop
      // renders

      if (script !== props.script) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          script: props.script
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          assetId = _this$props.assetId,
          description = _this$props.description,
          index = _this$props.index,
          duplicateShot = _this$props.duplicateShot,
          deleteShot = _this$props.deleteShot,
          provided = _this$props.provided,
          snapshot = _this$props.snapshot,
          selectShot = _this$props.selectShot,
          aspectRatio = _this$props.aspectRatio,
          isSelected = _this$props.isSelected,
          id = _this$props.id,
          hasDeletePermission = _this$props.hasDeletePermission;
      var script = this.state.script;
      return _react.default.createElement("div", (0, _extends2.default)({
        className: "shot",
        role: "button",
        id: id,
        ref: provided.innerRef,
        onClick: selectShot,
        tabIndex: 0,
        onKeyDown: selectShot
      }, provided.draggableProps, provided.dragHandleProps), _react.default.createElement("p", {
        className: (0, _classnames.default)('shot__title', {
          'shot__title--isSelected': isSelected
        })
      }, "Shot ".concat(index + 1)), _react.default.createElement("div", {
        className: (0, _classnames.default)('shot__wrapper', {
          shot__wrapper__selected: snapshot.isDragging || isSelected
        })
      }, _react.default.createElement(_ShotImage.default, {
        assetId: assetId,
        onDrop: this.updateAsset,
        aspectRatio: aspectRatio
      }), _react.default.createElement("div", {
        className: "shot__section"
      }, _react.default.createElement("div", {
        className: "shot__number-wrapper"
      }, _react.default.createElement("p", {
        className: "shot__number-text"
      }, index + 1)), script ? _react.default.createElement("p", {
        className: "shot__section__title"
      }, "Script") : null, _react.default.createElement(_AutoHeightTextArea.default, {
        onChange: this.updateField('script'),
        className: "shot__section__text-area",
        value: script,
        placeholder: "Enter script here...",
        onFocus: selectShot,
        "data-cy": "shot-script-".concat(index + 1)
      })), _react.default.createElement("div", {
        className: "shot__section"
      }, description ? _react.default.createElement("p", {
        className: "shot__section__title"
      }, "Description") : null, _react.default.createElement(_AutoHeightTextArea.default, {
        onChange: this.updateField('description'),
        className: "shot__section__text-area",
        value: description || '',
        placeholder: "Enter description here...",
        onFocus: selectShot,
        "data-cy": "shot-description-".concat(index + 1)
      })), isSelected && _react.default.createElement("div", {
        className: "shot__section row icon-row"
      }, _react.default.createElement(_uiKit.Icon, {
        name: "duplicate",
        color: "michael",
        hoverColor: "regent",
        onClick: duplicateShot,
        size: 20
      }), hasDeletePermission ? _react.default.createElement(_uiKit.Icon, {
        name: "trash",
        color: "michael",
        hoverColor: "regent",
        onClick: deleteShot,
        size: 20
      }) : null)));
    }
  }]);
  return Shot;
}(_react.Component);

exports.default = Shot;